/**
 * Footer for the umbrella marketing site — matches the reference mockup's
 * "For Car Owners / For Businesses / Company / Support" columns. Only
 * used on /, /used-cars, /estimate, /business — the /service/* legacy
 * sub-app keeps its existing Footer.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube, Linkedin } from 'lucide-react';

const COLUMNS = [
  {
    title: 'For Car Owners',
    links: [
      { name: 'Buy Used Cars', to: '/used-cars' },
      { name: 'Book Service', to: '/service' },
      { name: 'Find Workshops', to: '/service/services' },
    ],
  },
  {
    title: 'Company',
    links: [
      { name: 'About Us', to: '/service/about' },
      { name: 'Careers', to: '/service/about' },
      { name: 'Blog', to: '/service/about' },
      { name: 'Contact Us', to: '/service/contact' },
    ],
  },
  {
    title: 'Support',
    links: [
      { name: 'Help Center', to: '/service/contact' },
      { name: 'Privacy Policy', to: '/service/about' },
      { name: 'Terms & Conditions', to: '/service/about' },
    ],
  },
];

export default function PropitstopFooter() {
  return (
    <footer data-testid="propitstop-footer" className="bg-zinc-50 border-t border-zinc-200 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2">
              <img
                src="https://customer-assets.emergentagent.com/job_fcf8fe40-6235-4ae1-a5a5-ebd4002e0a55/artifacts/8jty1yq0_Gemini_Generated_Image_l9r4ujl9r4ujl9r4.png"
                alt="Propitstop"
                className="h-9 w-9 rounded-lg"
              />
              <div className="font-extrabold text-lg text-zinc-900">propitstop</div>
            </div>
            <p className="mt-3 text-sm text-zinc-500 leading-relaxed max-w-xs">
              Your trusted automotive partner for buying cars, servicing, and everything in between.
            </p>
            <div className="mt-4 flex items-center gap-3 text-zinc-500">
              <a href="#" aria-label="Facebook" className="hover:text-blue-600"><Facebook className="w-4 h-4" /></a>
              <a href="#" aria-label="Instagram" className="hover:text-blue-600"><Instagram className="w-4 h-4" /></a>
              <a href="#" aria-label="YouTube" className="hover:text-blue-600"><Youtube className="w-4 h-4" /></a>
              <a href="#" aria-label="LinkedIn" className="hover:text-blue-600"><Linkedin className="w-4 h-4" /></a>
            </div>
          </div>
          {COLUMNS.map((col) => (
            <div key={col.title}>
              <div className="text-sm font-bold text-zinc-900 mb-3">{col.title}</div>
              <ul className="space-y-2">
                {col.links.map((l) => (
                  <li key={l.name}>
                    <Link to={l.to} className="text-sm text-zinc-500 hover:text-blue-600 transition-colors">
                      {l.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-10 pt-6 border-t border-zinc-200 text-center text-xs text-zinc-500">
          © {new Date().getFullYear()} Propitstop. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
